<template>
  <div>
    <input type="radio" id="0" value="add" v-model="picked" />
    <label for="add">Addition</label>
    <br />
    <input type="radio" id="1" value="sub" v-model="picked" />
    <label for="sub">Substraction</label>
    <br />
    <input type="radio" id="2" value="multi" v-model="picked" />
    <label for="multi">Multiply</label>
    <br />
    <input type="radio" id="3" value="div" v-model="picked" />
    <label for="div">Divide</label>
    <br />
    <span>Picked: {{ picked }}</span>
  </div>
</template>

<script>
//import { constants } from "crypto";
export default {
  props: ["emitter", "ikey", "getData", "putData"],
  data() {
    return {
      picked: "add"
    };
  },
  methods: {
    update(newVal, oldVal) {
      if (this.ikey) {
        this.putData(this.ikey, this.picked);
      }
      if (this.emitter !== undefined) this.emitter.trigger("process");
    }
  },
  watch: {
    picked: function(newVal, oldVal) {
      this.update(newVal, oldVal);
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.picked = this.getData(this.ikey);
    //  console.log("getData key=" + this.ikey + " value=" + this.picked);
    }
  }
};
</script>

<style scoped>
label {
font-weight: bolder;
    font-family: "Comic Sans MS", cursive, sans-serif;
    text-align: center;
    font-size: x-large;
}
</style>
